module.exports = __webpack_public_path__ + "static/media/graphic-no-lead.e57212de.png";